<template>
  <fragment v-if="campaign">
    <div class="channel-edit-group channel-edit-group-field">
      <div class="channel-edit-field">
        <b-field :label="$t('CampaignEdit.CampaignTitle')">
          <b-input v-model="campaign.Title" :placeholder="$t('CampaignEdit.CampaignTitlePlaceholder')"></b-input>
        </b-field>
      </div>
    </div>
    <!--<div class="channel-edit-group channel-edit-group-dropdowns">
      <div class="dropdown-w">
        <b-field :label="$t('CampaignEdit.Company')">
          <b-dropdown :value="campaign.CompanyId" scrollable aria-role="list" :disabled="!companies.length || campaign.Id > 0" :label="$t('CampaignEdit.CampaignTitle')"
                @active-change="onDropdownActiveChange" @change="onCompanyChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedCompany ? selectedCompany.Title : $t("Campaigns.CompanyPlaceholder") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="companiesSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="company in companiesFiltered" :key="company.Id" :value="company.Id" aria-role="listitem">
              <span>{{ company.Title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
      </div>-->
      <div class="dropdown-w" v-if="campaign.Id > 0">
        <b-field :label="$t('CampaignEdit.ChannelMetadataType')">
          <b-dropdown :value="campaign.ChannelTypeId" scrollable aria-role="list" disabled
                @active-change="onDropdownActiveChange" @change="onChannelMetadataTypeChange($event)">
            <template #trigger>
              <b-button>
                <span class="dropdown-trigger-value">{{ selectedChannelMetadataType ? selectedChannelMetadataType.Title : $t("CampaignEdit.ChannelMetadataType") }}</span>
                <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
              </b-button>
            </template>
            <b-dropdown-item custom aria-role="listitem" class="filter-search">
              <b-input v-model="channelMetadataTypesSearch" class="search" :placeholder="$t('Search')" expanded />
            </b-dropdown-item>
            <b-dropdown-item v-for="channelMetadataType in channelMetadataTypesFiltered" :key="+channelMetadataType.Id" :value="+channelMetadataType.Id"
                  aria-role="listitem" class="dropdown-item-with-icon">
              <span class="icon-w" v-if="getChannelMetadataTypeIconName(channelMetadataType.Id)">
                <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channelMetadataType.Id) + '.png')" />
              </span>
              <span class="text">{{ channelMetadataType.Title }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </b-field>
      </div>
  </fragment>
</template>

<script lang="ts">
import VueCookies from "vue-cookies";
import Fragment from "vue-fragment";
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { Campaign, CampaignEditViewModel } from "@/models/campaigns/Campaign";
import { MultiselectItem } from "@/models/MultiselectItem";
import { CampaignEditPageKind } from "@/models/campaigns/CampaignEditPageKind";
import { AvailableChannelMetadataTypesMode, ChannelType } from "@/models/campaigns/ChannelType";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";
import { UserData } from "@/models/UserData";

Vue.use(Fragment.Plugin);
Vue.use(VueCookies);
const namespace = "campaignsModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
  },
})
export default class TabInfo extends Vue {

  //#region Vuex getters and actions

  @Getter("campaignEditViewModel", { namespace }) campaignEditViewModel!: CampaignEditViewModel;
  @Getter("companies", { namespace }) companies!: MultiselectItem[];
  @Getter("userData", { namespace: "mainModule" }) userData!: UserData;
  @Action("getCompanies", { namespace }) getCompanies!: () => Promise<MultiselectItem[]>;

  //#endregion Vuex getters and actions


  //#region Properties

  channelMetadataTypesSearch = "";
  companiesSearch = "";

  CampaignEditPageKind = CampaignEditPageKind;

  //#endregion Properties


  //#region Getters

  get campaign(): Campaign {
    return this.campaignEditViewModel?.Campaign;
  }

  get channelMetadataTypesFiltered(): MultiselectItem[] {
    const mode: AvailableChannelMetadataTypesMode = this.campaign.IsMediaChannel
          ? AvailableChannelMetadataTypesMode.MediaCampaigns : AvailableChannelMetadataTypesMode.Campaigns;
    return CampaignService.getChannelMetadataTypes(mode, this.channelMetadataTypesSearch.toLowerCase());
  }

  get companiesFiltered(): MultiselectItem[] {
    return this.companies.filter((i: MultiselectItem) => i.Title.toLowerCase().indexOf(this.companiesSearch.toLowerCase()) >= 0);
  }

  get pageKind(): CampaignEditPageKind {
    return CampaignService.getCampaignEditPageKind(this.$route.path);
  }

  get selectedChannelMetadataType(): MultiselectItem | undefined {
    const mode: AvailableChannelMetadataTypesMode = this.campaign.IsMediaChannel
          ? AvailableChannelMetadataTypesMode.MediaCampaigns : AvailableChannelMetadataTypesMode.Campaigns;
    return CampaignService.getChannelMetadataTypes(mode, this.channelMetadataTypesSearch.toLowerCase())
        .find((i: MultiselectItem) => +i.Id === this.campaign.ChannelTypeId);
  }

  get selectedCompany(): MultiselectItem | undefined {
    return this.companies.find((i: MultiselectItem) => +i.Id === this.campaign.CompanyId);
  }

  //#endregion Getters


  //#region Lifecycle

  mounted(): void {
    this.getCompanies().then(() => {
      if (this.campaign && this.campaign.Id === 0 && (!this.campaign.CompanyId || this.campaign.CompanyId === 0)) {
      if (this.userData?.CompanyId) {
         this.campaign.CompanyId = +this.userData.CompanyId;
        }
      }
    });
  }

  //#endregion Lifecycle


  //#region Handlers

  onChannelMetadataTypeChange(channelMetadataType: ChannelType): void {
    this.campaign.ChannelTypeId = +channelMetadataType;
  }
  
  onCompanyChange(companyId: number): void {
    this.campaign.CompanyId = companyId;
  }

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  //#endregion Handlers


  //#region Private methods

  private getChannelMetadataTypeIconName(type: string): string {
    return CampaignService.getChannelMetadataTypeIconName(+type);
  }

  //#endregion Private methods
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.channel-edit-group {
  margin-bottom: 25px;

  @media (max-width: $bp_md) {
    margin-bottom: 1rem;
  }

  &.channel-edit-group-field {
    max-width: 894px;

    .channel-edit-field {
      margin-bottom: 1rem;
    }

    .label {
      font-size: 17px;
      margin: 0;
      display: inline;
    }
  }

  &.channel-edit-group-dropdowns {
    display: flex;
    flex-wrap: wrap;
    max-width: 918px;
    margin: 0 -12px;

    .dropdown-w {
      padding: 0 12px 25px;
      flex-grow: 1;

      @media (max-width: $bp_md) {
        padding-bottom: 0;
        width: 100%;
      }

      .dropdown {
        width: 100%;

        .dropdown-item-with-icon {
          display: flex;

          .icon-w {
            display: flex;
            margin-inline-end: 0.5rem;
            min-width: 22px;

            img {
              max-height: 22px;
              min-width: 22px;
              width: 22px;
            }
          }
        }

        .dropdown-trigger {

          .button {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
